module.exports = __webpack_public_path__ + "images/harmonie-843ec402f6f81a80640cbf5852a76257.jpg";